import script from "./EmployeeCompletedFormsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeCompletedFormsView.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeCompletedFormsView.vue?vue&type=style&index=0&id=892d9c82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-892d9c82"]])

export default __exports__